// extracted by mini-css-extract-plugin
export default {"title":"title-4d30"};